'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgProfile(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M5.952 5.814c1.423 0 2.678-1.28 2.678-2.95C8.63 1.204 7.375 0 5.952 0c-1.416 0-2.67 1.237-2.67 2.881 0 1.653 1.254 2.933 2.67 2.933zM1.858 12h8.195c1.136 0 1.509-.322 1.509-.907C11.562 9.373 9.409 7 5.952 7 2.502 7 .35 9.373.35 11.093c0 .585.373.907 1.508.907z", id: "Profile_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Profile_svg__a" })))));
}

module.exports = SvgProfile;
//# sourceMappingURL=Profile.js.map
